import algoliasearch, { SearchClient } from 'algoliasearch';

import { FR } from '../../helpers/i18n';
import { API_ID, API_KEY, INDEX_NAME } from './algolia-config';

const singletons: Record<string, SearchClient> = {};

export const getClient = (key = API_KEY, id = API_ID): SearchClient => {
  let client = singletons[key];
  if (!client) {
    client = algoliasearch(id, key);
    singletons[key] = client;
  }
  return client;
};

export const getAlgoliaIndexName = (lang = FR): string =>
  `${INDEX_NAME}_${lang}_lglp`;
